<template>
  <div>
    <custom-dialog class="recommendRecharge_warp_dialog" v-if="showRechargeDialog" width="780px"
      :visible="showRechargeDialog">
      <div slot="content" class="recommendRecharge_warp_content">
        <div class="recommendRecharge_warp_content_left">
          <el-form class="member-warp" inline :model="memberFormInfo">
            <div class="member-warp-content">
              <el-form-item prop="memberName">
                <el-select popper-class="customSelectStyle" class="name-select" v-model="memberFormInfo.memberName"
                  placeholder="会员姓名" filterable remote reserve-keyword value-key="memberId" disabled
                  @change="selectMemberHandle">
                  <el-option v-for="item in memberList" :key="item.memberId" :value="item" class="display-f">
                    <span style="width: 96px; display:inline-block;" class="mr12 text-overflow">
                      {{ item.patientName }}
                    </span>
                    <span class="mr24">{{ item.sex == '0' ? '男' : (item.sex == '1' ? '女' : '未知') }}</span>
                    <span style="width: 72px; display:inline-block" class="mr24">
                      {{ item.age }}岁{{ item.ageMth }}月
                    </span>
                    <span style="width: 112px; display:inline-block">{{ item.phone }}</span>
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item prop="sex">
                <el-select v-model="memberFormInfo.sex" class="sex-select" :popper-append-to-body="false" placeholder=""
                  disabled>
                  <el-option
                    v-for="item in [{ label: '男', value: '0' }, { label: '女', value: '1' }, { label: '未知', value: '2' }]"
                    :key="item.value" :label="item.label" :value="item.value" />
                </el-select>
              </el-form-item>
              <el-form-item prop="year">
                <el-input ref="year" class="year-input" v-model="memberFormInfo.year" disabled>
                </el-input>
                <div class="append">岁</div>
              </el-form-item>
              <el-form-item prop="month">
                <el-input ref="month" class="month-input" v-model="memberFormInfo.month" disabled>
                </el-input>
                <div class="append month">月</div>
              </el-form-item>
              <el-form-item prop="phone" style="margin-right: 0">
                <el-select ref="phoneSelectRef" class="phone-select" popper-class="customSelectStyle"
                  v-model="memberFormInfo.phone" placeholder="手机号码" filterable remote reserve-keyword
                  :remote-method="getMemberListByPhone" value-key="memberId" @change="selectMemberHandle">
                  <el-option v-for="item in memberList" :key="item.memberId" :value="item">
                    <span style="width: 96px; display:inline-block" class="mr12">{{ item.memberName }}</span>
                    <span class="mr24">{{ item.sex === '0' ? '男' : (item.sex === '1' ? '女' : '未知') }}</span>
                    <span style="width: 72px; display:inline-block" class="mr24">
                      {{ item.year }}岁{{ item.month }}月</span>
                    <span style="width: 112px; display:inline-block">{{ item.phone }}</span>
                  </el-option>
                </el-select>
              </el-form-item>
              <div v-if="memberFormInfo.memberId" class="edit-btn" @click="editMemberHandle">
                <i class="el-icon-edit-outline" style="font-size:18px;color:#87939F;cursor: pointer;"></i>
              </div>
            </div>
            <div v-if="showAddBtn" class="add-btn" @click="addMemberHandle">新增</div>
          </el-form>
          <div class="member-form-warp">
            <h4>请选择充值金额：</h4>
            <div class="recharge-list">
              <div v-for="item in rechargeList" :key="item.id" class="recharge-list-item"
                :class="{ active: item.id === currentRechargeId }" @click="chooseAmtHandle(item.id)">
                <span v-if="item.id === recommendRechargeId" class="active-tips">推荐档位</span>
                <div class="recharge-amt">
                  <div>￥{{ item.amt }}</div>
                  <div class="last_recharge" v-if="item.amt == chargePotential.lastTopUpLevel">上次充值</div>
                </div>
              </div>
            </div>
            <!-- 活动列表 -->
            <div class="coupon" v-loading="activityLoading" v-if="activityList.length > 0">
              <div class="activity-item" :class="{ 'last': activityList.length - 1 === index }"
                v-for="(item, index) in activityList" :key="index">
                <p class="activity-tips">
                  <span v-if="activityList.length > 1">
                    <el-radio v-model="activityId" :label="item.activityId">活动{{ index + 1 }}：</el-radio>
                  </span>
                  <span>赠送总值<span class="amt">{{ item.totalAmt || 0 }}元</span>的券包，共{{ item.totalNum || 0 }}张</span>
                </p>
                <div class="coupon-list">
                  <div class="coupon-list-item" v-for="(items, i) in (item.coupons || [])" :key="i">
                    <div class="coupon-list-item-title">
                      <span class="num">{{ items.couponMoney }}</span>
                      <span>元</span>
                      <span> X </span>
                      <span class="num">{{ items.count }}</span>
                      <span>张</span>
                    </div>
                    <div class="coupon-list-item-limit">
                      <div class="coupon-list-item-limit-tips">
                        {{ items.couponMoneyFloor ? `满${items.couponMoneyFloor}元可用` : '无门槛券' }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- 门店及销售人员选择 -->
            <el-form class="seal-form" :model="sealFormInfo">
              <el-form-item prop="deptId" label="销售门店 :">
                <el-select v-model="sealFormInfo.deptId" placeholder="请选择销售门店" popper-class="customSelectStyle"
                  disabled>
                  <el-option v-for="item in deptList" :key="item.value" :value="item.value"
                    :label="item.label"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item prop="sealId" label="销售人员 :">
                <el-select popper-class="customSelectStyle" class="name-select" v-model="sealFormInfo.sealId"
                  placeholder="请选择销售人员" filterable>
                  <el-option v-for="item in sealList" :key="item.userId" :value="item.userCode"
                    :label="item.nickName"></el-option>
                </el-select>
              </el-form-item>
            </el-form>
          </div>
          <div class="member-form-warp-btn">
            <el-button @click="cancelHandle">取消</el-button>
            <el-button type="primary" @click="confirmHandle">确定</el-button>
          </div>
        </div>
        <div class="recommendRecharge_warp_content_right" v-if="chargePotential && chargePotential.patientInfo">
          <div class="recommendRecharge_warp_content_right_top">患者信息</div>
          <div class="recommendRecharge_warp_content_right_content">
            <div class="right_content_patient">
              <div>
                <span class="right_content_patient_label">患者</span>
                <span class="right_content_patient_value">{{ chargePotential.patientInfo.patientName }}
                  {{ chargePotential.patientInfo.sex == '1' ? '男' : '女' }} {{ chargePotential.patientInfo.age }}岁{{
                    chargePotential.patientInfo.ageMonth }}月</span>
              </div>
              <div v-if="chargePotential.patientInfo.labelList">
                <div class="right_content_patient_label_list">
                  <div class="label_list_item" v-for="(item, index) in chargePotential.patientInfo.labelList"
                    :key="index">{{ item.labelResult }}</div>
                </div>
              </div>
            </div>
            <div class="right_content_record">
              <div class="right_content_record_title">就诊记录</div>
              <div class="right_content_record_list" v-if="chargePotential.patientDiagVoList">
                <div class="right_content_record_list_item" v-for="(item, index) in chargePotential.patientDiagVoList"
                  :key="index">
                  <div class="right_content_record_list_item_top">
                    <div class="record_list_item_top_left">{{ $moment(item.schedulingDate).format('YYYY-MM-DD') }}</div>
                    <div class="record_list_item_top_right">
                      <span class="record_list_item_top_right_label">消费：</span>
                      <span class="record_list_item_top_right_value">￥{{ item.totalCharge || '' }}</span>
                    </div>
                  </div>
                  <div class="right_content_record_list_item_desc">{{ item.diagnosis }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div slot="footer"></div>
    </custom-dialog>

    <!-- 确认充值信息 -->
    <RechargeConfirmDialog v-model="showRechargeConfirmDialog" :rechargeOrderInfo="rechargeOrderInfo"
      @confirm="showPayTypeDialogHandle" />

    <!-- 选择支付方式 -->
    <ChoosePayTypeDialog v-model="showChoosePayTypeDialog" :loading="loading" :payBtnLoading="payBtnLoading"
      :rechargeOrderInfo="rechargeOrderInfo" @confirm="submitPayTypeHandle" />

    <!-- 好码齐支付弹窗 -->
    <HowMuchDialog v-if="howMuchVisibleObj.howmuchDialog" :visibleObj="howMuchVisibleObj" :dialogObj="howMuchDialogObj"
      @close="howMuchVisibleObj.howmuchDialog = false" @updateData="howMuchPayHandle" />
  </div>
</template>
<script>
import { debounce, isNull } from '@/utils/validateBase'
import req from '@/utils/request'
import { productRechargeList, testRechargeList } from '@/utils/const'
export default {
  components: {
    CustomDialog: () => import('@/components/customDialog/CustomDialog'),
    MemberDialog: () => import('@/views/Patient/MemberList/components/dialog/MemberDialog.vue'),
    RechargeConfirmDialog: () => import('@/views/Patient/MemberList/components/dialog/RechargeConfirmDialog'),
    ChoosePayTypeDialog: () => import('@/views/Patient/MemberList/components/dialog/ChoosePayTypeDialog'),
    HowMuchDialog: () => import('@/components/howmuchDialog/index')
  },
  props: {
    showRechargeDialog: {
      type: Boolean,
      default: false
    },
    showAddBtn: {
      type: Boolean,
      default: false
    },
    memberInfo: {
      type: Object,
      default() {
        return {
          memberName: null,
          sex: "0",
          year: null,
          month: null,
          day: null,
          birthday: null,
          phone: null,
          source: null
        }
      }
    },
    chargePotential: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {

      // 当前用户选择好的会员信息
      memberFormInfo: {},
      memberList: [],
      // 当前用户要修改的会员信息
      currentMemberInfo: {},
      showMemberDialog: false, // 是否显示会员弹框

      // 充值金额列表
      rechargeList: process.env.VUE_APP_ENV === 'production' ? productRechargeList : testRechargeList,

      currentRechargeId: '',
      recommendRechargeId: '',
      // 优惠券列表
      activityList: [],
      activityId: '',
      activityLoading: false,

      // 门店及销售人员选择
      sealFormInfo: {
        deptId: this.$session.get('deptId'),
        sealId: ''
      },
      deptList: this.$session.get('options').filter(item => item.value !== 0),
      sealList: [],
      rechargeOrderInfo: {}, // 充值订单信息

      // 会员充值确认
      showRechargeConfirmDialog: false,

      // 收费确认弹框
      loading: false, // 好码齐支付查询支付结果loading
      showChoosePayTypeDialog: false,
      payBtnLoading: false, // 收费按钮loading

      // 好码齐弹窗
      howMuchVisibleObj: {
        howmuchDialog: false
      },
      // 好码齐弹窗数据
      howMuchDialogObj: {
        price: 0
      },

      confirmBtnLoading: false,

    }
  },
  watch: {
    memberInfo: {
      handler(newVal) {
        this.memberFormInfo = newVal
      },
      immediate: true
    },
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      // 初始化充值金额初始化数据
      if (isNull(this.chargePotential.topUpLevel)) {
        this.currentRechargeId = this.rechargeList.length <= 0 ? '' : this.rechargeList[0].id
      } else {
        let index = this.rechargeList.findIndex(v => { return v.amt == this.chargePotential.topUpLevel })
        this.recommendRechargeId = index == -1 ? this.rechargeList[0].id : this.rechargeList[index].id
        this.currentRechargeId = this.recommendRechargeId
      }
      this.getRechargeActivityList()
      this.sealFormInfo.sealId = this.$session.get('user').userCode
      this.memberList = []
      this.getSealList()
    },

    // 根据电话获取会员列表
    getMemberListByPhone: debounce(async function (phone) {
      if (!phone) {
        return this.memberList = []
      }
      const params = { phone }
      let { code, data } = await req.get('/system/member/get/phone', params)
      if (code === 200) {
        if (!data) return this.memberList = []
        if (data.birthday) data.birthday = data.birthday.slice(0, 10)
        this.$computeAge(data.birthday, data)
        this.memberList = [{
          ...data,
          sex: data.sex || '2'
        }]
      } else {
        this.memberList = []
      }
    }, 300),

    // 获取指定门店下的人员列表
    async getSealList() {
      const { code, rows } = await req.get('/system/user/list')
      if (code === 200) {
        this.sealList = rows || []
      }
    },

    // 更新会员信息(新增和修改会员信息后)
    updateMemberInfoHandle(memberInfo = {}) {
      this.$emit('updateMemberInfoHandle', memberInfo)
    },

    addMemberHandle() {
      this.currentMemberInfo = {
        memberName: '',
        sex: '0',
        year: '',
        month: '',
        day: '',
        birthday: '',
        phone: '',
        source: '',
      }
      this.showMemberDialog = true
    },

    editMemberHandle() {
      this.currentMemberInfo = {
        ...this.memberFormInfo
      }
      this.showMemberDialog = true
    },

    // 选择患者
    selectMemberHandle(item) {
      this.memberList = []
      this.memberFormInfo = item
      this.$emit('updateMemberInfoHandle', item)
    },

    chooseAmtHandle(id) {
      this.currentRechargeId = id
      this.getRechargeActivityList()
    },

    // 获取会员充值对应的送券活动
    async getRechargeActivityList() {
      const amt = (this.rechargeList.find(item => item.id === this.currentRechargeId) || {}).amt
      const params = {
        rechargeAmount: amt
      }
      this.activityLoading = true
      const { code, data } = await req.get('/middMarketing/queryMiddActivity', params)
      this.activityLoading = false
      if (code === 200) {
        this.activityList = (data || []).filter(item => item.coupons.every(items => items.thresholdAmount === amt)).map(item => ({
          ...item,
          totalAmt: (item.coupons || []).reduce((a, b) => (a * 1) + ((b.count || 0) * (b.couponMoney || 0)), 0),
          totalNum: (item.coupons || []).reduce((a, b) => (a * 1) + ((b.count || 0) * 1), 0),
        }))
        if (this.activityList.length === 1) {
          this.activityId = this.activityList[0].activityId
        } else if (this.activityList.length > 1) {
          this.activityId = this.activityList.at(-1).activityId
        } else {
          this.activityId = ''
        }
      } else {
        this.activityList = []
      }
    },

    // 提交
    async confirmHandle() {
      if (!this.memberFormInfo.memberId) return this.$message.error('请选择会员')
      if (!this.currentRechargeId) return this.$message.error('请选择充值金额')
      if (this.activityList.length > 0 && !this.activityId) return this.$message.error('请选择活动')
      if (isNull(this.sealFormInfo.sealId)) return this.$message.error('请选择销售人员')
      const params = {
        channel:1,
        memberId: this.memberFormInfo.memberId,
        amount: (this.rechargeList.find(item => item.id === this.currentRechargeId) || {}).amt,
        deptId: this.sealFormInfo.deptId,
        activityId: this.activityId,
        ...this.sealFormInfo.sealId && { salesPersonCode: this.sealFormInfo.sealId }
      }
      this.confirmBtnLoading = true
      const { code, data } = await req.post('/member/wallet/recharge/create', params)
      this.confirmBtnLoading = false
      if (code === 200) {
        this.showRechargeConfirmDialog = true
        this.rechargeOrderInfo = {
          ...this.memberFormInfo,
          ...data
        }
      }
    },

    // 改变状态（切换弹窗）
    showPayTypeDialogHandle() {
      this.showRechargeConfirmDialog = false
      this.showChoosePayTypeDialog = true
    },

    // 提交支付方式
    submitPayTypeHandle(payType) {
      // 2:现金 3:好码齐
      if (payType === 2) {
        // 现金
        this.pay(payType)
      } else if (payType === 3) {
        // 好码齐
        this.howMuchDialogObj = {
          price: this.rechargeOrderInfo.prePayAmount
        }
        this.howMuchVisibleObj.howmuchDialog = true
      }
    },

    // 好码齐支付
    async howMuchPayHandle(dataObj) {
      // dataObj: { payWay: 3, userAuthCode: this.payQrCode, price: this.dialogObj.price }
      await this.pay(dataObj.payWay, dataObj.userAuthCode)
      this.howMuchVisibleObj.howmuchDialog = false
    },

    // 支付
    async pay(payType, userAuthCode = '') {
      const payWayInfo = {
        2: 'CASH', // 现金
        3: 'HOW_MUCH'  // 好码齐
      }
      const params = {
        rechargePayRecordId: this.rechargeOrderInfo.id,
        payWay: payWayInfo[payType],
        ...(!!userAuthCode) && {
          attach: {
            userAuthCode: userAuthCode
          }
        }
      }
      this.payBtnLoading = true
      const { data, code } = await req.post('/member/wallet/recharge/pay', params)
      this.payBtnLoading = false
      if (code === 200) {
        if (data.result) {
          if (payType === 2) {
            this.$emit('updateOrderNumHandle', data.rechargePayNumber)
            this.paySuccessHandle()
          } else {
            // 好码齐支付轮巡查订单支付结果
            this.getOrderPayStatus(data.rechargePayNumber)
            this.loading = true
          }
        } else {
          this.$message.error(data.message)
        }
      }
    },

    // 好码齐支付，获取支付结果
    async getOrderPayStatus(payOrderNumber) {
      const params = {
        rechargePayNumber: payOrderNumber || ''
      }
      const { code, data } = await req.get(`/member/wallet/recharge/pay/info`, params)
      if (code === 200) {
        if (data.status === 'SUCCESS') {
          this.$emit('updateOrderNumHandle', payOrderNumber)
          this.loading = false
          this.paySuccessHandle()
        } else if (data.status === 'FAIL') {
          this.loading = false
          this.showChoosePayTypeDialog = false
          this.$message.error('支付失败')
        } else if (data.status === 'PROGRESS') {
          setTimeout(() => {
            this.getOrderPayStatus(payOrderNumber)
          }, 1000)
        }
      }
    },

    // 支付成功
    paySuccessHandle() {
      this.showChoosePayTypeDialog = false
      this.dialogVisible = false
      this.$emit('showPaySuccessDialogHandle', 'pay')
    },
    cancelHandle() {
      this.$emit('cancelHandle', 'cal')
    }
  },
}
</script>
<style scoped lang="less">
/deep/ .dialog-content {
  padding-top: 12px !important;
}

/deep/ .el-dialog__body {
  padding: 0 !important;
}

/deep/ .el-date-table th {
  text-align: center;
}

/deep/ .el-form-item__error {
  padding-top: 4px;
}

/deep/ .el-form-item__content {
  line-height: 32px;

  .el-input {
    min-width: 0 !important;
  }
}

.el-input,
.el-select {
  height: 38px;
  border-radius: 2px;
  box-sizing: border-box;
}


.search .el-input,
.search .el-select {
  min-width: 0 !important;
}
</style>
<style lang="less" scoped>
.recommendRecharge_warp_dialog {
  /deep/.el-dialog {
    background: transparent;
    box-shadow: none;
  }

  /deep/.dialog-content {
    padding: 0;
  }
}

.recommendRecharge_warp_content {
  display: flex;
  max-height: 680px;
  overflow: hidden;

  .recommendRecharge_warp_content_left {
    width: 440px;
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    border-radius: 6px;

    .member-warp {
      display: flex;
      padding: 16px;
      border-bottom: 1px solid #EBEAEE;
      background: #C9E2FF;

      .member-warp-content {
        position: relative;
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 0 !important;
        padding-top: 4px;
        box-sizing: border-box;
        width: 100%;
        height: 32px;
        background-color: #fff;
        border-radius: 4px 4px 4px 4px;
        border: 1px solid #DCDFE6;
      }

      /deep/.el-form-item {
        margin-bottom: 0;
        margin-right: 0;
      }

      .name-select {
        width: 100px;
      }

      .sex-select {
        width: 50px;

        /deep/ .el-input__inner {
          text-align: center;
        }

        /deep/ .el-input__suffix {
          display: none;
        }
      }

      .year-input {
        width: 50px;
        position: relative;
      }

      .month-input {
        width: 48px;
        position: relative;
      }

      .append {
        position: absolute;
        top: 0;
        right: 6px;
        color: #1F2329;
        font-size: 14px;

        &.month {
          right: 10px;
        }
      }

      .phone-select {
        width: 130px;

        /deep/ .el-input__suffix {
          display: none;
        }
      }

      .add-btn,
      .edit-btn {
        width: 32px;
        height: 32px;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 0 !important;

        &.visible-hidden {
          visibility: hidden;
        }
      }

      .add-btn {
        width: 50px;
        margin-left: 4px;
        background: #FFFFFF;
        border-radius: 4px 4px 4px 4px;
        border: 1px solid #DCDFE6;
        color: #1890ff;
        cursor: pointer;
      }

      .edit-btn {
        position: absolute;
        right: 0px;
        top: 0px;
      }

      /deep/.el-input__inner {
        padding: 6px 6px;
        border-color: transparent;
        box-sizing: border-box;
        background-color: transparent;
      }


      /deep/ .el-input.is-disabled .el-input__inner {
        background-color: transparent !important;
        color: #1F2329;
        border-color: transparent !important;
      }
    }

    // 充值内容区域
    .member-form-warp {
      flex: 1;
      color: #000;
      padding: 16px 20px;
      padding-bottom: 0;
      background: #fff;
      display: flex;
      flex-direction: column;
      box-sizing: border-box;
      overflow: hidden;
    }

    .member-form-warp .recharge-list {
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      grid-gap: 10px;
      padding-top: 16px;
    }

    .member-form-warp .recharge-list .recharge-list-item {
      position: relative;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      height: 64px;
      background: #F7F8F9;
      border-radius: 6px 6px 6px 6px;
      border: 1px solid #E0E0E0;
      cursor: pointer;

      &.active {
        background: #F1F8FF;
        border-radius: 6px 6px 6px 6px;
        border: 1px solid #1890FF;
        color: #1890FF;

        .give-amt {
          color: #1890FF;
          border: 1px solid rgba(24, 144, 255, 0.5);
        }
      }

      .active-tips {
        position: absolute;
        left: -1px;
        top: -6px;
        width: 64px;
        height: 20px;
        background: #F54A45;
        border-radius: 4px;
        color: #fff;
        font-size: 12px;
        line-height: 18px;
        text-align: center;
      }

      &:hover {
        border: 1px solid #1890FF;
      }

      // 本金
      .recharge-amt {
        font-size: 22px;
        font-weight: 600;

        .last_recharge {
          font-weight: 400;
          font-size: 12px;
          color: #A4AFBA;
          text-align: center;
          margin-top: 8px;
        }
      }
    }

    /**
  优惠券
*/
    .coupon {
      margin-top: 16px;
      flex: 1;
      overflow: auto;

      .activity-item {
        padding-bottom: 14px;

        &.last {
          padding-bottom: 0;
        }
      }

      .activity-tips {
        font-size: 14px;
        color: #667182;

        /deep/ .el-radio__label {
          font-weight: 600;
        }

        // 解决选择radio控制台报错 begin
        /deep/ input[aria-hidden="true"] {
          display: none !important;
        }

        /deep/ .el-radio:focus:not(.is-focus):not(:active):not(.is-disabled) .el-radio__inner {
          box-shadow: none !important;
        }

        // 解决选择radio控制台报错 end
        span.amt {
          font-size: 16px;
          color: #FE8F1F;
        }
      }

      .coupon-list {
        display: grid;
        grid-template-columns: repeat(4, 1fr);
        grid-gap: 10px;
        padding-top: 14px;
        font-size: 12px;
        color: #68481D;

        .coupon-list-item {

          .coupon-list-item-title,
          .coupon-list-item-limit {
            height: 29px;
            line-height: 28px;
            text-align: center;
            border-radius: 4px;
            background: linear-gradient(137deg, #FFE9B6 0%, #FFE19C 100%);
          }

          .coupon-list-item-title {
            span.num {
              font-weight: bold;
              font-size: 16px;
              color: #68481D;
            }
          }

          .coupon-list-item-limit {

            .coupon-list-item-limit-tips {
              margin: 0 auto;
              width: 86%;
              border-top: 1px dashed #E4BB84;
              white-space: nowrap;
            }
          }
        }
      }
    }

    //门店及销售人员
    .seal-form {
      margin-top: 16px;
      padding-top: 16px;
      border-top: 1px dashed #E0E0E0;

      /deep/.el-form-item {
        margin-bottom: 0;
      }

      /deep/ .el-form-item__label {
        color: #000;
        line-height: 32px;
      }

      /deep/ .el-form-item__content {
        margin-bottom: 16px;
      }
    }

    .member-form-warp-btn {
      text-align: right;
      padding: 16px;
      background: #fff;
    }

  }

  .recommendRecharge_warp_content_right {
    width: 332px;
    max-height: 662px;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    background: #F3F3F3;
    border-radius: 6px 6px 6px 6px;
    margin-left: 8px;

    .recommendRecharge_warp_content_right_top {
      height: 56px;
      line-height: 56px;
      padding: 0 15px;
      font-weight: 500;
      font-size: 16px;
      color: #1D2129;
      border-bottom: 1px solid #E0E0E0;
    }

    .recommendRecharge_warp_content_right_content {
      padding: 16px;
      flex: 1;
      display: flex;
      flex-direction: column;
      overflow: hidden;

      .right_content_patient {
        .right_content_patient_label {
          color: #667182;
          font-weight: 400;
          font-size: 16px;
        }

        .right_content_patient_value {
          font-size: 16px;
          font-weight: 500;
          color: #000000;
          margin-left: 16px;
        }

        .right_content_patient_label_list {
          display: flex;
          flex-wrap: wrap;
          gap: 8px;
          margin-top: 14px;

          .label_list_item {
            height: 24px;
            line-height: 20px;
            padding: 0 10px;
            background: #FFFFFF;
            border-radius: 23px 23px 23px 23px;
            border: 1px solid #92F0B7;
            font-weight: 400;
            font-size: 14px;
            color: #0DBB4A;
            box-sizing: border-box;
          }
        }
      }

      .right_content_record {
        margin-top: 16px;
        flex: 1;
        display: flex;
        flex-direction: column;
        overflow: hidden;

        .right_content_record_title {
          font-weight: 400;
          font-size: 16px;
          color: #667182;
        }

        .right_content_record_list {
          flex: 1;
          display: flex;
          flex-direction: column;
          gap: 8px;
          overflow: auto;
          margin-top: 12px;
          padding-right: 2px;

          .right_content_record_list_item {
            padding: 8px;
            background: #FFFFFF;
            border-radius: 4px 4px 4px 4px;
            border: 1px solid #D3D3D5;
            box-sizing: border-box;

            .right_content_record_list_item_top {
              display: flex;
              align-items: center;
              justify-content: space-between;

              .record_list_item_top_left {
                font-weight: bold;
                font-size: 14px;
                color: #333333;
              }

              .record_list_item_top_right {
                font-size: 14px;

                .record_list_item_top_right_label {
                  color: #6D7075;
                  font-weight: 400;
                }

                .record_list_item_top_right_value {
                  color: #000;
                  font-weight: bold;
                }
              }
            }

            .right_content_record_list_item_desc {
              font-weight: 400;
              font-size: 14px;
              color: #6D7075;
              margin-top: 12px;
            }
          }

        }
      }
    }
  }
}
</style>